import { render, staticRenderFns } from "./TableCustomer.vue?vue&type=template&id=6caed479&scoped=true&"
import script from "./TableCustomer.vue?vue&type=script&lang=js&"
export * from "./TableCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TableCustomer.vue?vue&type=style&index=0&id=6caed479&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caed479",
  null
  
)

export default component.exports